new Swiper("#stepPicturesAndTextDiv", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        touchRatio:1.5,
        centeredSlides : true,
        navigation:{
            prevEl: '#imgListLeftMobileArrowPrev',
            nextEl: '#imgListLeftMobileArrowNext',
        },
        on: {

        },
    });